import { faCircleExclamation } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch } from '@redux';
import {
  getByIdOrdersReturn,
  passQCOrderReturn,
} from '@redux/ordersReturn/actions';
import { Button, Form, Modal, Space } from 'antd';
import useToggleModal from 'hooks/useToogleModal';
import React, { useImperativeHandle, useState } from 'react';
import { useTranslation } from 'react-i18next';

const PassQCConfirmModal = ({ id }, ref) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const { visible, toggleModal } = useToggleModal();
  const [loading, setLoading] = useState(false);

  useImperativeHandle(ref, () => ({
    open: () => {
      toggleModal();
    },
  }));

  const handleOk = async () => {
    setLoading(true);
    dispatch(passQCOrderReturn({ data: { id: id } }))
      .then(() => {
        dispatch(
          getByIdOrdersReturn({
            data: { id: id },
            options: { isRequestApi: true, isRefresh: true },
          }),
        ).finally(() => {
          setLoading(false);
          if (visible) toggleModal();
        });
      })
  };

  return (
    <Modal
      open={visible}
      title={null}
      footer={null}
      closeIcon={null}
      onCancel={() => visible && toggleModal()}
      onOk={() => form.submit()}
      width={443}
      className="flex flex-col items-center"
    >
      <Space size={0} direction="vertical" className="items-center">
        <FontAwesomeIcon
          icon={faCircleExclamation}
          className="text-text-primary text-[24px]"
        />
        <p className="text-text-dark-gray font-semibold text-[16px] mt-[5px]">
          {t('ordersReturn.confirmInformation')}
        </p>
        <p className="my-[20px]">{t('ordersReturn.confirmText')}</p>
        <div className="flex items-center gap-[10px]">
          <Button
            disabled={loading}
            onClick={() => toggleModal()}
            className="btn-light btn-h-32"
          >
            Cancel
          </Button>
          <Button
            loading={loading}
            onClick={handleOk}
            type="primary"
            className="btn-h-32"
          >
            OK
          </Button>
        </div>
      </Space>
    </Modal>
  );
};

export default React.forwardRef(PassQCConfirmModal);
